import { axiosPost } from '../../plugins/axios.plugins';

const API_ENDPOINTS = {
  FILE_PARSER_API: `${process.env.VUE_APP_FILE_PARSER_API}`,
};

export const getExportedFile = (payload, options) => {
  return axiosPost(
    `${API_ENDPOINTS.FILE_PARSER_API}/export-as-file`,
    payload,
    options
  );
};

export const fileParserApi = (payload, options = {}) => {
  return axiosPost(`${API_ENDPOINTS.FILE_PARSER_API}/parse`, payload, options);
};

export const getSchemaByFile = (payload, options = {}) => {
  return axiosPost(
    `${API_ENDPOINTS.FILE_PARSER_API}/create-schema`,
    payload,
    options
  );
};
